import { defineStore } from "pinia";
import { ref, computed, readonly } from "vue";
import { logger } from "@/infrastructure/services/LoggerService";
export const useAccountStore = defineStore("account", () => {
    // State
    const accountInfo = ref(null);
    const isLoading = ref(false);
    const error = ref(null);
    // Actions
    const setAccountInfo = (info) => {
        accountInfo.value = info;
        logger.debug("Account store: Account info updated", info);
    };
    const setLoading = (loading) => {
        isLoading.value = loading;
    };
    const setError = (errorMessage) => {
        error.value = errorMessage;
        if (errorMessage) {
            logger.debug("Account store: Error set", errorMessage);
        }
    };
    const clearError = () => {
        error.value = null;
    };
    const reset = () => {
        accountInfo.value = null;
        isLoading.value = false;
        error.value = null;
        logger.debug("Account store: Reset to initial state");
    };
    // Getters
    const hasAccountInfo = computed(() => accountInfo.value !== null);
    // Check if onboarding status is "Initialized"
    const showOnboardingIcon = computed(() => {
        // If no account info, hide onboarding
        if (!accountInfo.value)
            return false;
        // if the onboardingStatus is anything other than "Completed", show the icon
        return accountInfo.value.onboardingStatus !== "Completed";
    });
    // Check if account status is "Active" AND onboarding is "Completed"
    // A compte is only truly active when both conditions are met
    const isAccountActive = computed(() => {
        if (!accountInfo.value)
            return false;
        return (accountInfo.value.accountStatus === "Active" &&
            accountInfo.value.onboardingStatus === "Completed");
    });
    return {
        // State (readonly)
        accountInfo: readonly(accountInfo),
        isLoading: readonly(isLoading),
        error: readonly(error),
        // Actions
        setAccountInfo,
        setLoading,
        setError,
        clearError,
        reset,
        // Getters
        hasAccountInfo,
        showOnboardingIcon,
        isAccountActive,
    };
});
